module.exports = __webpack_public_path__ + "img/cross-circle-white.c38db79e.svg";